
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/tag/[tag]",
      function () {
        return require("private-next-pages/blog/tag/[tag].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/tag/[tag]"])
      });
    }
  